import React, { FC, memo } from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export interface GenButtonProps extends ButtonProps {
  loading?: boolean;
}

const GenButton: FC<GenButtonProps> = (props) => {
  const { loading, color, children, disabled, ...otherProps } = props;
  return (
    <Button
      color={color || "primary"}
      variant="contained"
      disabled={loading ? true : disabled}
      endIcon={loading && <CircularProgress color={color} size={18} />}
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default memo(GenButton);
